<app-spinner></app-spinner>
<div class="content">
  <div
    *ngIf="shown.grid"
    class="col-md-12 col-sm-12 col-xs-12 col-lg-12"
    style="padding: 10px;"
  >
    <mat-card style="margin-bottom: 10px; padding: 5px;">
      <mat-form-field appearance="outline" style="width: 30%;">
        <mat-label>Search Phone No</mat-label>
        <input #searchMobileNumber
          matInput
          type="text"
          (keypress)="numberOnly($event)"
          (keyup)="userFilter($event.target.value)"
        />
      </mat-form-field>
      <div
        style="float: right; padding: 10px; cursor: pointer;"
        mat-raised-button
        color="blue "
        class=" "
        (click)="openDialog()"
        mat-flat-button
      >
        <img
          src="assets/img/icons/group-31.png "
          matTooltip="Add"
          matTooltipPosition="left"
        />
      </div>
    </mat-card>

    <mat-card>
      <!--   <div>
            <mat-form-field appearance="outline" style="width:30%">
                <mat-label>Search Phone No</mat-label>
                <input matInput type="text" (keyup)="userFilter($event.target.value)">
            </mat-form-field>
            <div style="float: right;padding:10px " mat-raised-button color="blue " class=" " (click)="openDialog() " mat-flat-button><img src="assets/img/icons/group-31.png "></div>
        </div> -->
      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        class="mat-elevation-z8"
        style="width: 100%;"
      >
        <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

        <ng-container matColumnDef="userId">
          <th mat-header-cell *matHeaderCellDef>Id</th>
          <td mat-cell *matCellDef="let element">{{ element.userId }}</td>
        </ng-container>

        <ng-container matColumnDef="Sno">
          <th mat-header-cell *matHeaderCellDef>S.No</th>
          <td mat-cell *matCellDef="let element">
            {{ dataSource.filteredData.indexOf(element) + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            User Mobile Number
          </th>
          <td mat-cell *matCellDef="let element">{{ element.mobile }}</td>
        </ng-container>

        <ng-container matColumnDef="configure">
          <th mat-header-cell *matHeaderCellDef>Configure</th>
          <td
            mat-cell
            *matCellDef="let element"
           
          >
            <!--  <mat-icon style="width:2%;cursor: pointer;">
                    settings</mat-icon> -->
            <img  (click)="openuserconfigdialog(element.userId)"
              style="cursor: pointer; height: 22px;"
              src="assets/img/icons/Config.png"
              matTooltip="Configure"
              matTooltipPosition="left"
            />
          </td>
        </ng-container>

        <ng-container matColumnDef="activity">
          <th mat-header-cell *matHeaderCellDef>Activity</th>
          <td
            mat-cell
            *matCellDef="let element"
            
          >
            <img (click)="openactivitydialog(element.userId)"
              style="cursor: pointer;"
              src="assets/img/icons/activity.png"
              matTooltip="Activity"
              matTooltipPosition="left"
            />
          </td>
        </ng-container>

        <ng-container matColumnDef="isLock">
          <th mat-header-cell *matHeaderCellDef>Account Lock</th>
          <td mat-cell *matCellDef="let element">
            <img
              *ngIf="element.isLock"
              (click)="openunlockDialog(element.userId)"
              style="cursor: pointer;"
              src="assets/img/icons/lock.png"
              matTooltip="Unlock"
              matTooltipPosition="left"
            />
            <img
              *ngIf="!element.isLock"
              (click)="openlockDialog(element.userId)"
              style="cursor: pointer;"
              src="assets/img/icons/unlock.png"
              matTooltip="Lock"
              matTooltipPosition="left"
            />
            <!-- <div (click)="lock(element.userId)">lock</div> -->
          </td>
        </ng-container>

        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef>Edit</th>
          <td
            mat-cell
            *matCellDef="let element"
            
          >
            <img
              style="cursor: pointer;" (click)="editUser(element.userId)"
              src="assets/img/icons/forma-1-copy-2.png "
              matTooltip="Edit"
              matTooltipPosition="left"
            />
          </td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef>Delete</th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            
          >
            <img
              style="cursor: pointer;" (click)="deleteUser(element.userId, i)"
              src="assets/img/icons/forma-1.png "
              matTooltip="Delete"
              matTooltipPosition="left"
            />
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator
        [pageSizeOptions]="[10, 20, 100]"
        showFirstLastButtons
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        (page)="pageEvent = handlePage($event)"
      ></mat-paginator>
    </mat-card>
  </div>
</div>
